import { BookDemoPage } from '@features/onboarding/components/login/BookDemoPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/book-demo/')({ component: BookDemoPage });
